var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { activationStrategy } from "aurelia-router";
import { computedFrom } from "aurelia-binding";
import { EntityTypeConfigurationHelper } from "../../models/basics/basics.models";
import * as Enumerable from "linq";
import { Reflection } from "../../utilities/reflection";
import { DialogClientService } from "../../services/basics/dialog-client.service";
import { AllViewQueryConfigurationConstants } from "../../models/basics/view-query.models";
var ViewQueryDialog = /** @class */ (function () {
    function ViewQueryDialog(entityTypeConfigurationHelper, dialogClientService) {
        this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        this.dialogClientService = dialogClientService;
        this.fixedColumns = [];
        this.fixedFilters = [];
        this.onColumnPushed = function (column) { };
        this.onColumnsPrepared = function (columns) { };
        this.entityTypeConfigurations = this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions([]);
    }
    ViewQueryDialog.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    Object.defineProperty(ViewQueryDialog.prototype, "allColumns", {
        get: function () {
            return this.queryEditor && this.queryEditor.columns && this.fixedColumns
                ? this.queryEditor.columns.concat(this.fixedColumns)
                : [];
        },
        enumerable: false,
        configurable: true
    });
    ViewQueryDialog.prototype.activate = function (model) {
        var _this = this;
        this.model = model;
        this.uri = model.uri;
        this.title = model.title;
        var entityConfigurationModel = Enumerable.from(this.entityTypeConfigurations).firstOrDefault(function (x) { return x.uri && x.uri.replace(/ /g, "").toLowerCase() == _this.uri.replace(/-/g, "").toLowerCase(); });
        var viewQueryConfigurationModel = Enumerable.from(AllViewQueryConfigurationConstants).firstOrDefault(function (x) { return x.uri && x.uri.replace(/ /g, "").toLowerCase() == _this.uri.replace(/-/g, "").toLowerCase(); });
        if (viewQueryConfigurationModel) {
            this.title = viewQueryConfigurationModel.title;
            this.onRowSelected = viewQueryConfigurationModel.onRowSelected;
            this.settings = viewQueryConfigurationModel.settings;
            this.enableUploadExcel = viewQueryConfigurationModel.enableUploadExcel;
            this.queryHeaderViewModel = viewQueryConfigurationModel.queryHeaderViewModel;
        }
        this.gridSettings = entityConfigurationModel.gridConfig;
        this.fixedFilters = entityConfigurationModel.filters ? entityConfigurationModel.filters : [];
        this.fixedColumns = entityConfigurationModel.fixedColumns ? entityConfigurationModel.fixedColumns : [];
        this.editRoute = entityConfigurationModel.editRoute ? (typeof entityConfigurationModel.editRoute == "string" ? entityConfigurationModel.editRoute : entityConfigurationModel.editRoute.name) : null;
        this.hasNavbar = entityConfigurationModel.navbar != null && entityConfigurationModel.navbar != "";
        this.clickMode = viewQueryConfigurationModel && viewQueryConfigurationModel.clickMode ? viewQueryConfigurationModel.clickMode : "double";
        this.getParams = viewQueryConfigurationModel && viewQueryConfigurationModel.getParams ? viewQueryConfigurationModel.getParams : function (item) { return ({ id: item ? item.id : 0 }); };
        this.sortAlphabetically = viewQueryConfigurationModel && 'sortAlphabetically' in viewQueryConfigurationModel ? viewQueryConfigurationModel.sortAlphabetically : true;
        this.onColumnPushed = viewQueryConfigurationModel && viewQueryConfigurationModel.onColumnPushed ? viewQueryConfigurationModel.onColumnPushed : function (column) { };
        this.onColumnsPrepared = viewQueryConfigurationModel && viewQueryConfigurationModel.onColumnsPrepared ? viewQueryConfigurationModel.onColumnsPrepared : function (columns) { };
        //DO NOT REMOVE BECAUSE IT IS NEEDED FOR WEBPACK 
        if (!window["SystemJS"]) {
            require("" + "app/views/pages/queries/navbar/" + this.uri + "-navbar");
        }
        if (this.queryEditor)
            this.queryEditor.reloadData(true);
    };
    ViewQueryDialog.prototype.close = function () {
        this.dialogClientService.hide();
    };
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.queryEditor; }), Reflection.getPropertyPath(function (x) { return x.queryEditor.columns; }), Reflection.getPropertyPath(function (x) { return x.fixedColumns; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ViewQueryDialog.prototype, "allColumns", null);
    ViewQueryDialog = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [EntityTypeConfigurationHelper,
            DialogClientService])
    ], ViewQueryDialog);
    return ViewQueryDialog;
}());
export { ViewQueryDialog };
